import { createResource } from '@atlassian/react-resource-router';
import type { FetchThirdpartyConnectorsResponse } from './types.tsx';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-knowledge-base-thirdparty-connectors", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-thirdparty-connectors" */ './get-data'
	);

export const servicedeskKnowledgeBaseThirdpartyConnectorsResource =
	createResource<FetchThirdpartyConnectorsResponse>({
		type: 'SERVICEDESK_KNOWLEDGE_BASE_THIRDPARTY_CONNECTORS',
		getKey: ({ match }) => match.params.projectKey || '',
		getDataLoader,
		maxAge: Infinity,
	});
